import { CroppingEditOptions, CroppingMultipleTargetUpdateOptions } from "@omnia/shared/fields"
import { FieldsMap, FieldViewModel, ICropping, IField, IOmniaCommandGroup, IOmniaService, IOmniaShell, IParam, ParamKey, SharedFieldsService } from "./omnia"

export interface IFieldEditModel extends IField {

    EditOptions?: {
        UpdateCropArea: boolean
        DeleteBoundary: boolean
        UpdateCroppingBoundaries: boolean
        CreateUncroppedAreas: boolean
    }

}

export interface IFieldsService extends IOmniaService, SharedFieldsService {

    getParameters(type: ParamKey): IParam[]

    selectedFields: FieldViewModel[]
    selectedCroppings: FieldViewModel[]

    selectSingleField(fieldId: number): void
    selectSingleCropping(croppingId: number): void

    setView(map: boolean): void
    readonly mapView: boolean
    readonly timelineView: boolean

    createField(data: IFieldEditModel): ng.IPromise<any>
    updateFields(fieldIds: number[], data: IFieldEditModel): ng.IPromise<any>
    editFieldBoundary(fieldId: number, boundary: string): ng.IPromise<any>
    canDeleteField(fieldId: number): ng.IPromise<FieldDependencies>
    deleteField(fieldId: number, admin: boolean): ng.IPromise<any>

    createCropping(data: ICropping): ng.IPromise<any>
    updateCropping(croppingIds: number[], data: ICropping, editOptions?: CroppingEditOptions, multiTargetOptions?: CroppingMultipleTargetUpdateOptions): ng.IPromise<any>
    splitCropping(split: ICroppingSplitModel): ng.IPromise<ICropping[]>
    mergeCropping(merge: ICroppingMergeModel): ng.IPromise<ICropping>
    canDeleteCropping(ids: number[]): ng.IPromise<CroppingDependencies[]>
    deleteCropping(croppingId: number, admin: boolean, layers: "delete" | "realloc"): ng.IPromise<any>

    updateDisabledFields(model: IFieldDisableModel[]): ng.IPromise<any>
    createDisabledCropping(fieldId: number, year: number): ng.IPromise<ICropping>

}


export interface IFieldsModuleContext {

    readonly svc: IFieldsService
    readonly editSvc: IFieldsEditService
    readonly shell: IOmniaShell

    readonly readOnly: boolean

    readonly map: FieldsMap
    readonly mapView: boolean

    startComponent(options: omnia.shell.IComponentStartOptions): omnia.shell.IComponentContext

}


export enum FieldsEditTarget {
    None = 0,
    Field = 1,
    Cropping = 2
}

export interface IFieldsEditService {

    readonly targetType: FieldsEditTarget
    readonly isEditing: boolean

    multiple: boolean

    readonly field: IField
    readonly fields: IField[]

    readonly cropping: ICropping[]

    startEditing(cropping: boolean, target: IField | ICropping): void
    stopEditing(): void

    canSelectAsEditTarget(item: FieldViewModel): boolean
    selectCropping(cropping: FieldViewModel, select: boolean): boolean

}

export interface ICroppingSplitModel {

    HoldingId: number
    YearId: number

    FieldId: number
    CroppingId: number

    DeleteLayers: boolean

    Splits: {

        RetainCroppingInfo?: boolean,

        GrassMargin?: boolean

        Area?: number,
        BoundaryWKT?: string,

    }[]

}

export interface ICroppingMergeModel {

    HoldingId: number
    YearId: number

    FieldId: number
    CroppingId: number

    Area: number
    BoundaryWKT?: string

    MergedCrops: number[]

}

export interface FieldDependencies {
    FieldId: number
    HasCropping: boolean
    HasLayers: boolean
    HasSoilAnalysis: boolean
    HasPcnAnalysis: boolean
    HasHealthySoilAssements: boolean
    HasDraftSprayPlans?: boolean
    HasPublishedSprayPlans?: boolean
    HasTasks?: boolean
}

export interface CroppingDependencies {
    CroppingId: number
    HasLayers?: boolean
    HasPlanLayer?: boolean
    HasNitrogenAnalysis?: boolean
    HasFieldPerformanceData?: boolean
    HasSuccessorsInPlans?: boolean
    HasDraftSprayPlans?: boolean
    HasPublishedSprayPlans?: boolean
    HasTasks?: boolean
}


export interface IFieldDisableModel {
    FieldId: number
    IgnoreBoundary?: boolean
    DisabledYears: number[]
}

export interface IFieldsMapCroppingDetailsContext {
    readonly map: FieldsMap;
    getSelectedCroppings(): FieldViewModel[];
    commands: IOmniaCommandGroup;
}

export interface IFieldsMapCroppingDetailsScope extends omnia.map.IMapDetailsBoxScope {
    context: IFieldsMapCroppingDetailsContext;
}